import {Elem} from '../services/html';

export function Infobox(
  message: string,
  isError = false,
  executionId?: string,
): HTMLElement {
  let msg = message;

  if (executionId) {
    msg += '\n\nIf you contact support, tell them this code: ' + executionId;
  }

  return Elem('div', {
    class: 'sc-infobox' + (isError ? ' sc-errorbox' : ''),
    text: msg,
  });
}
